import * as c from './actions/config';

export const Configs = c;
